import { usePropertyData } from '@context/property-context'
import ChevronDownIcon from '@icons/ChevronDownIcon'
import pushToDataLayer from '@logic/data-layers/pushToDataLayer'
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { AccordionWrapper, Body, Header, Item, Right } from './styles'
import { AccordionProps } from './types'

const AccordionItem = ({ item, index, setOpen, open }) => {
  const [height, setHeight] = useState(0)
  const isOpen = open === index
  const innerBodyRef = useRef<HTMLDivElement>(null)
  const { activeProperty } = usePropertyData()

  const setInnerBodyHeight = () => {
    if (innerBodyRef?.current?.offsetHeight) {
      setHeight(innerBodyRef.current.offsetHeight)
    }
  }

  useLayoutEffect(() => {
    setInnerBodyHeight()
  }, [innerBodyRef?.current?.offsetHeight])

  useEffect(() => {
    setInnerBodyHeight()
  }, [open])

  useEffect(() => {
    setInnerBodyHeight()
    window.addEventListener('resize', setInnerBodyHeight)
    return () => {
      window.removeEventListener('resize', setInnerBodyHeight)
    }
  }, [])

  return (
    <Item open={isOpen}>
      <Header
        onClick={() => {
          pushToDataLayer({
            event: 'interaction',
            event_name: isOpen ? 'faq_closed' : 'faq_open',
            product: activeProperty?.classification ? 'mewoz' : 'payments',
            classification: activeProperty?.classification || null,
            title: (item.title || '').toLowerCase()
          })
          setOpen(isOpen ? null : index)
        }}
      >
        {item.title && <p>{item.title}</p>}
        <Right>
          <ChevronDownIcon />
        </Right>
      </Header>
      <Body style={{ height: isOpen ? `${height + 1}px` : '0px' }}>
        { typeof item.content === 'string' ? 
            <div ref={innerBodyRef} dangerouslySetInnerHTML={{ __html: item.content }} />
          :
            <div ref={innerBodyRef}>
              {item.content}
            </div>
        }
      </Body>
    </Item>
  )
}

const Accordion = ({ items, defaultOpen = 0 }: AccordionProps) => {
  const [rendered, setRendered] = useState(false)
  const [open, setOpen] = useState<number | null>(defaultOpen)
  useEffect(() => {
    setRendered(true)
  }, [])
  
  return (
    <AccordionWrapper rendered={rendered}>
      {items.length > 0 &&
        items.map((item, index) => (
          <AccordionItem key={index} index={index} item={item} open={open} setOpen={setOpen} />
        ))}
    </AccordionWrapper>
  )
}

export default Accordion
